/**
 * The backend's own friendly `error` text from a failed raw Response (authedFetch / fetch callers that can't
 * go through request()), else `fallback`. Reads the body as text first, so an HTML proxy error page (nginx's
 * 413, a 502) never throws. Extracted from services/api.ts uploadErrorMessage (Bug 25.05 #2), which keeps
 * using it; lives outside api.ts so jest can load it (api.ts reads import.meta.env).
 *
 * #2289 — the tax-form downloads showed "Download failed (404)" instead of the server's
 * "This tax form file is no longer available — please re-upload."
 */
export async function serverErrorMessage(resp: Response, fallback: string): Promise<string> {
  const raw = await resp.text().catch(() => '');
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed.error === 'string' && parsed.error.trim()) return parsed.error;
    } catch {
      /* HTML / non-JSON body (e.g. a proxy error page) — fall through */
    }
  }
  return fallback;
}
